module.exports = __webpack_public_path__ + "img/part-4-info.a1aa9908.png";